import React, { createContext, useContext, useState } from 'react';
import { startOfDay, endOfDay, addDays } from "date-fns";

const DateRangeContext = createContext();

export const DateRangeProvider = ({ children }) => {
    const [startDate, setStartDate] = useState(startOfDay(addDays(new Date(), -1)));
    const [endDate, setEndDate] = useState(endOfDay(addDays(new Date(), 6)));

    return (
        <DateRangeContext.Provider 
            value={{ 
                startDate, 
                setStartDate, 
                endDate, 
                setEndDate 
            }}
        >
            {children}
        </DateRangeContext.Provider>
    );
};

export const useDateRangeContext = () => useContext(DateRangeContext);